<template>
  <div wrapper>
    <!-- <slot/> -->
  </div>
</template>

<script>
export default {
  name: 'Wrapper',
};
</script>

<style lang="less">
@import "~@/less/proj";
[wrapper] { .p(0,20); }
@media (min-width: @screen-md-min) {
  [wrapper] { .p(0,30); }
}
@media (min-width: @screen-lg-min) {
  [wrapper] { .p(0,40); }
}
@media (min-width: @screen-xl-min) {
  [wrapper] { .w(1280); .p(0); .mh-c; }
}
</style>
